import type { FC } from 'react';
import { Box, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import type { UserActionsProps } from '@components/common/Header/UserActions.interface';
import { PROFILE_PATH } from '@routes/path';
import LanguageSelector from '@components/ui/LanguageSelector';
import { useLanguage } from '../../../contexts/LanguageContext';
import translations from './translations.json';

type SupportedLanguage = keyof typeof translations;

const UserActions: FC<UserActionsProps> = ({
  userProfile,
  onLogout,
  isMobile = false,
}) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  if (isMobile) {
    return (
      <Box sx={{ px: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <LanguageSelector />
        </Box>
        {userProfile && (
          <>
            <Button
              component="a"
              href={PROFILE_PATH}
              variant="outlined"
              size="small"
              sx={{
                color: '#FFFFFF',
                borderColor: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: '#FFFFFF',
                },
              }}
            >
              <FontAwesomeIcon icon={faUser} />
              {userProfile?.username}
            </Button>
            <Button
              onClick={onLogout}
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: '#FFFFFF',
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                },
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              {content.logout}
            </Button>
          </>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <LanguageSelector />
      {userProfile && (
        <>
          <Button
            component="a"
            href={PROFILE_PATH}
            variant="outlined"
            size="small"
            sx={{
              color: '#FFFFFF',
              borderColor: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderColor: '#FFFFFF',
              },
            }}
          >
            <FontAwesomeIcon icon={faUser} />
            {userProfile?.username}
          </Button>
          <Button
            onClick={onLogout}
            variant="outlined"
            size="small"
            sx={{
              color: '#FFFFFF',
              borderColor: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderColor: '#FFFFFF',
              },
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
            {content.logout}
          </Button>
        </>
      )}
    </Box>
  );
};

export default UserActions;
